module.exports = __webpack_public_path__ + "static/media/gryphon_musee_hero_visit.8a9c4e2a.jpg";